import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";


export class ActeComponentExtended extends ShadowDOMElement {
	static className = "ActeComponentExtended";
	
	static properties = {
		register1: { type: String, attribute: "register1" },
		register2: { type: String, attribute: "register2" }
	};
	
	constructor (){
		super ();
		this.register1 = "bordereau";
		this.register2 = "case";
	}
	
	firstUpdated (){
		this.#updateContainers1 ();
		this.#updateContainers2 ();
	}
			
	render() {
    return html`
      <div>
        <title-field label="Acte"></title-field>
        <row-wrapper>
          <select-field
            id="nature-acte"
            label="Nature de l'acte *"
            value="0"
            required
            @change="${this.handleSelectChange}"
			name="id_act_nature"
          >
            <option-component label="Choisir" value="0"></option-component>
            <option-component label="Acte authentique" value="1"></option-component>
            <option-component label="Acte sous seing privé" value="2"></option-component>
          </select-field>
        </row-wrapper>

        <div id="acte-fields" style="display: none;">
          <row-with-tooltip tooltip-text="Indiquer uniquement la ville.">
            <text-field id="lieu_signature" label="Lieu de la signature" name="act_location"></text-field>
          </row-with-tooltip>
          <row-wrapper>
            <date-field id="date_acte" label="Date de l'acte" name="act_date"></date-field>
          </row-wrapper>

          <title-field label="Enregistrement au SIE"></title-field>
          <row-with-tooltip tooltip-text="Indiquer uniquement la ville.">
            <text-field id="ville_enregistrement" label="Ville" name="city"></text-field>
          </row-with-tooltip>
		  <row-wrapper>
		  <radio-buttons-field name="register-1" id="register1"
		    .options="${[
		      { title: 'Bordereau', value: 'bordereau' },
		      { title: 'Dossier', value: 'dossier' },
		    ]}"
		    value="bordereau"
		    @change="${this.handleRadioChange1}"
		  ></radio-buttons-field>
		  </row-wrapper>
          <row-wrapper>
		  	<div-container id="divDossier">
            <text-field id="dossier" label="Dossier" name="dossier"></text-field>
			</div-container>
          </row-wrapper>
		  <row-wrapper>
		  	<div-container id="divBordereau">
		    <text-field id="bordereau" label="Bordereau" name="bordereau"></text-field>
			</div-container>
		  </row-wrapper>
		  <row-wrapper>
		  <radio-buttons-field name="register-2" id="register2"
		    .options="${[
		      { title: 'Case', value: 'case' },
		      { title: 'Référence', value: 'reference' },
		    ]}"
		    value="case"
		    @change="${this.handleRadioChange2}"
		  ></radio-buttons-field>
		  </row-wrapper>
          <row-wrapper>
		  	<div-container id="divCase">
            <text-field id="case" label="Case" name="case"></text-field>
			</div-container>
          </row-wrapper>
		  <row-wrapper>
		  	<div-container id="divReference">
		    <text-field id="reference" label="Référence" name="reference"></text-field>
		    </div-container>
		  </row-wrapper>
          <row-wrapper>
            <date-field id="date_enregistrement" label="Date d'enregistrement" name="registration_date"></date-field>
          </row-wrapper>
        </div>
      </div>
    `;
	}

	handleSelectChange(event) {
		const value = event.target.value;
		const fieldsContainer = this.shadowRoot.querySelector("#acte-fields");
		const inputFields = [
			"lieu_signature",
			"date_acte",
			"ville_enregistrement",
			"date_enregistrement",
			"case",
			"reference",
			"bordereau",
			"dossier"
		].map((id) => this.shadowRoot.querySelector(`#${id}`));

		if (value === "0") {
			fieldsContainer.style.display = "none";
			inputFields.forEach((field) => {
				field.required = false;
				this.updateLabel(field, false);
			});
		} else {
			fieldsContainer.style.display = "block";
			const isRequired = value === "2";
			inputFields.forEach((field) => {
				field.required = isRequired;
				this.updateLabel(field, isRequired);
			});
		}
	}

	updateLabel (field, isRequired) {
		const label = field.getAttribute("label");
		if (!label)
			return;
		
		if (isRequired){
			if (!label.endsWith(" *"))
				field.setAttribute("label", `${label} *`);
		} else
			field.setAttribute("label", label.replace(/ \*$/, ""));
	}
	
	handleRadioChange1 (event){
		if (!event.detail)
			return;
		
		this.register1 = event.detail.value;		
		this.#updateContainers1 ();
	}

	handleRadioChange2 (event){
		if (!event.detail)
			return;
		
		this.register2 = event.detail.value;		
		this.#updateContainers2 ();
	}
	
	isTransient (){
		return false;
	}
	
	#updateContainers1 (){
		const divDossier = this.shadowRoot.querySelector ("#divDossier");
		const divBordereau = this.shadowRoot.querySelector ("#divBordereau");
		
		divDossier.visible = this.register1 === "dossier";
		divBordereau.visible = this.register1 === "bordereau";
	}
	
	#updateContainers2 (){
		const divCase = this.shadowRoot.querySelector ("#divCase");
		const divReference = this.shadowRoot.querySelector ("#divReference");
		
		divCase.visible = this.register2 === "case";
		divReference.visible = this.register2 === "reference";
	}
	
	getValues (){
		return {
			"register1" : this.register1,
			"register2" : this.register2,
			... super.getValues ()
		}
	}
	
	setValues (values){
		this.register1 = values.register1;
		this.register2 = values.register2;
		super.setValues (values);
		this.#updateContainers1 ();
		this.#updateContainers2 ();
		this.requestUpdate ();
	}
}

customElements.define("acte-component-extended", ActeComponentExtended);
